export const getLoginFieldMsg =
{
  email: 'Email is Required.',
  password: 'Password is Required.',
}
export const getBranchFieldMsg =
{
  name: 'Branch Name is Required.',
  registrationNumber: 'Registration Number is Required.',
  contactNumber: 'Contact Number is Required.',
  openingTime: 'Branch Opening Time is Required.',
  closingTime: 'Branch Closing Time is Required.',
  address: 'Address is Required.',
  trackingCode: 'Tracking Code is Required',
  operationalHours: 'Operational Hours is Required'
}
export const getParentFieldMsg =
{
  name: 'Name is Required.',
  dateOfBirth: 'Date of Birth is Required.',
  mobileNumber: 'Mobile Number is Required.',
  primaryLanguage: 'Primary Language is Required.',
  nationalInsuranceNumber: 'National Insurance Number is Required.',
  address: 'Address is Required.',
  email: 'Email Address is Required',
  organizationName:'Organization name is required.',
  type:'Account Type is required.',
  title:'Title is required.',
  homeLandLineNumber: 'Home Landline No is Required.',
  workTelephoneNumber: 'Work Telephone No is Required.',
  childId:'Child is required',
  guardianRelationId:'Relation is required.',
  relationLabel:'Relation is required.'

}
export const getAddressDialogFieldMsg =
{
  address: 'Street Address or PO Box is Required.',
  streetNumber: 'Street Address or PO Box is Required.',
  streetAddress: 'Street Address is Required.',
  city: 'Town/City is Required.',
  postalCode: 'Postal/Zip Code is Required.'
}
export const globalSettingFieldMsg =
{
    category: 'Category is Required.',
  name: 'Name is Required.',
  matRate: 'Amount is Required.',
}
export const getEventDialogFieldMsg =
{
  type: 'Type is Required.',
  description: 'Maximum of 300 characters allowed.',
  startDate: 'Start Date is Required.',
  endDate: 'End Date is Required.',
}
export const getRoomFieldMsg =
{
  name: 'Room Name is Required.',
  area: 'Area is Required',
  ageGroupId: 'Age Band is Required.',
  ageLabel: 'Age Band is Required.',
  length: 'Length is Required.',
  width: 'Width is Required.',
  totalCapacity: 'Capacity is Required.',
}
export const getInformationFieldMsg =
{
  name: 'Session Name Required.',
  // category: 'Please select session profile.',
  startTime: 'Start Time is Required.',
  endTime: 'End Time is Required.',
  matEffectiveFrom: 'Effective From is Required.'
}
export const getPricingFieldMsg =
{
  effectiveFromDate: 'Effective From is Required.',
  dailyTimeRate: 'Daily Rate is Required.',
  fullTimeRate: 'Full Time Rate is Required.',
  hourlyTimeRate: 'Hourly Rate is Required.',
}
export const getStaffPersonalDetailMsg =
{
  firstName: 'First Name is Required.',
  lastName: 'Surname is Required.',
  mobileNumber: 'Contact Number is Required.',
  email: 'Email Address is Required.',
  address: 'Address is Required.',
  matDateOfBirth: 'Date of Birth is Required.',
  nationality: 'Nationality is Required.',
  gender: 'Gender is Required.',
  religion: 'Religion is Required.',
  ethnicOrigin: 'Ethnic Origin is Required.',
  firstLanguage: 'First Language is Required.',
  dietaryRequirement: 'Dietary is Required.',
  carRegistrationNumber: 'Car Registration is Required.',
  telephoneNumber: 'Please Enter Valid Home Telephone.',
  nationalInsuranceNumber: 'Insurance No is Required.',
  name: 'Name is Required.',
  relationToEmployee: 'Relation to employee is Required.',
  bankSocietyName: 'Bank/Building Name is Required.',
  accountName: 'Account Name is Required.',
  accountNumber: 'Account Number is Required.',
  sortCode: 'Sort Code is Required.',
  personalEmail: 'Personal email is required',
  relationLabel: 'Relation is Required'
}
export const getContractFieldMsg =
{
  contractType: 'Contract Type is Required.',
  matemploymentStartDate: 'Start Date is Required.',
  matemploymentEndDate: 'End Date is Required.',
  jobTitle: 'Job Title is Required.',
  branchId: 'Primary Setting is Required.',
  branchLabel: 'Primary Setting is Required.',
  contractHours: 'Contract Hours is Required.',
  paymentMode: 'Payment mode is Required.',
  contractWeeks: 'Contract Weeks is Required.',
  contractRate: 'Contract Rate is Required.',
  payCycleId: 'Pay Cycle is Required.',
  duration: 'Duration is Required.',
}
export const getShiftPatternFieldMsg =
{
  roomId: 'Room is Required.',
  roomLabel: 'Room is Required.',
  matStartTime: 'Start Time is Required.',
  matEndTime: 'End Time is Required.',
  breakDeduction: 'Break Deduction is Required.',
}
export const getBasicInfoFieldMsg =
{
  firstName: 'First name is Required.',
  lastName: 'Surname is Required.',
  gender: 'Gender is Required.',
  knownAs: 'knownAs is Required.',
  matDateOfBirth: 'Date Of Birth is Required.',
  matRegistrationDate: 'Registration Date is Required.',
  nationality: 'Nationality is Required.',
  ethnicOrigin: 'Ethnic Origin is Required.',
  firstLanguage: 'First Language is Required.',
  religion: 'Religion is Required.',
  religiousFestivals: 'Religious Festivals is Required.',
  birthCertificateNumber: 'Birth Certificate # is Required.',
  passportNumber: 'Passport is Invalid.',
  nurseryName: 'Nursery Name is Required.',
  matStartDate: 'Start Date is Required.',
  matEndDate: 'End Date is Required.',
  discount: 'Value should be less than 100',
  matDiscount: 'Value should be less than 100',
  childDiscountType: 'Discount Type is Required'
}
export const getOffboardingFieldMsg ={
  noticeGiven:'Notice Given Date is required',
  reason:'Reason is required',
  leaveDate:'Leave Date is required'
}
export const getGuardianInfoFieldMsg =
{
  title: 'Title is Required.',
  name: 'Name is Required.',
  relationToChild: 'Relation To Child is Required.',
  matDateOfBirth: 'Date Of Birth is Required.',
  address: 'Address is Required.',
  languageLabel: 'Primary Language is Invalid.',
  nationalInsuranceNumber: 'Insurance No is Required.',
  homeLandLineNumber: 'Home Landline No is Required.',
  mobileNumber: 'Mobile No is Required.',
  workTelephoneNumber: 'Work Telephone No is Required.',
  email: 'Email Address is Required.',
  type:'Account Type is required.',
  landlineNo:'Landline number is required.',
  guardianName:'Guardian is required',
  organizationName:'Organization name is required.'
}
export const getMedicalInfoFieldMsg =
{
  doctorName: 'Doctor Name is Required.',
  workTelephoneNumber: 'Telephone No is Required.',
  surgeryName: 'Surgery Name is Required.',
  address: 'Address is Required.',
  doesChildHaveAnySpecialDietOrHealthProblemOrAllergiesDescription: 'Please enter those details here.',
  areThereAnyProfessionalsInvolvedWithTheChildDescription: 'Please enter those details here.',
  healthVisitorName: 'Health Visitor’s Name is Required.',
  prescribedMedicationTokenDescription: 'Prescribed Medication Taken is Required.',
  isTheChildBeingTreatedAtAHospitalDescription: 'Please enter those details here.',
  areChildImmunitiesUpToDateDescription: 'Please enter those details here.',
  doesTheChildHaveEarlyYearActionOrSupportDescription: 'Please enter those details here.',
  doesTheChildHaveAnyDistinguishingMarksDescription: 'Please enter those details here.',
  wasTheChildBornPrematurelyDescription: 'Please enter those details here.',
  doParentsHaveAnyConcernsOverTheChildDevelopmentDescription: 'Please enter those details here.',
}
export const getEmergencyInfoFieldMsg =
{
  name: 'Name is Required.',
  relationToChild: 'Relation To Child is Required.',
  homeLandLineNumber: 'Home Landline No is Required.',
  mobileNumber: 'Mobile No is Required.',
  workTelephoneNumber: 'Work Telephone No is Required.',
  email: 'Email Address is Required.',
  placeOfWork: 'Place of work is Required.',
  address: 'Address is Required.',
}
export const getFieldMsg =
{
  nameEn: 'Name in english is Required.',
  nameUr: 'Name in urdu is Required.',
  address: 'Address is Required.',
  coveredArea: 'Covered area is Required.',
  capacity: 'Capacity is Required.',
  gardenerId: 'Gardener is Required.',
}
export const getAdminFieldMsg =
{
  name: 'Admin name is invalid.',
  email: 'Email is invalid',
  password: 'Password is invalid.',

}

export const getProfileFieldMsg =
{
  currentPassword: 'Current password is invalid.',
  newPassword: 'New password is invalid',
  confirmPassword: 'Confirm password is invalid.',
}

export const getNurseryFieldMsg =
{
  nameEn: 'Nursery name is invalid.',
  nameUr: '.براہ کرم نرسری کا صحیح نام استعمال کریں',
  address: 'Address is invalid.',
  coveredArea: 'Covered Area is invalid.',
  capacity: 'Capacity is invalid.',
  gardenerId: 'Gardener is Required.',
}
export const getInventoryFieldMsg =
{
  quantity: 'Quantity is invalid.',
  nameUr: '.براہ کرم نرسری کا صحیح نام استعمال کریں',
  address: 'Address is invalid.',
  coveredArea: 'Covered area is invalid.',
  capacity: 'Capacity is invalid.',
  gardenerId: 'Gardener is Required.',
}

export const getSpecieFieldMsg =
{
  nameEn: 'Species name is invalid.',
  nameUr: '.براہ کرم پودے کا صحیح نام استعمال کریں',
  alternativeNameEn: 'Specie alternative name is invalid.',
  alternativeNameUr: '.براہ کرم پودے کا صحیح متبادل نام استعمال کریں',
  seedCountPerKg: 'Seed count is invalid.',
  benchmarkSuccessRatio: 'Benchmark success ratio is invalid.',
}
export const getGardenerFieldMsg =
{
  nameEn: 'Gardener name is invalid.',
  nameUr: '.براہ کرم باغبان کا صحیح نام استعمال کریں',
  dateOfBirth: 'Date of birth is invalid.',
  loginPin: 'Gardener code is invalid',
  identityNumber: 'Gardener code is invalid',
  nurseryId: 'Nursery is Required.',
  role: 'Role is invalid.',
  contactNumber: 'Contact number is invalid',
  address: ' Address is invalid',
  workSchedule: ' Work schedule is invalid',
  profilePicture: ' Image is invalid',
  status: ' Status is invalid',
}

export const getHeadGardenerFieldMsg =
{
  nameEn: 'Gardener name is invalid.',
  nameUr: '.براہ کرم باغبان کا صحیح نام استعمال کریں',
  dateOfBirth: 'Date of birth is invalid.',
  loginPin: 'Pin code is invalid',
  identityNumber: 'Gardener code is invalid',
  nurseryId: 'Nursery is Required.',
  role: 'Role is invalid.',
  contactNumber: 'Contact number is invalid',
  address: ' Address is invalid',
  workSchedule: ' Work schedule is invalid',
  profilePicture: ' Image is invalid',
  status: ' Status is invalid',
}

export const getInvoiceFieldMsg =
{
  invoiceDate: 'Invoice Date is Required',
  dueDate: 'Due Date is Required',
  child: 'Child is Required',
  guardian: 'Parent/Guardian is Required',
  address: 'Address is Required',
  additionalItemId: 'Item is Required'
}

export const getCreditsFieldMsg =
{
  matAmount: 'Amount is required',
  memo: 'Memo is Required',
  end: 'Date is Required',

}

export const getFundingFieldMsg =
{
    passCode: 'Minimum 3 and maximum 18 characters allowed',
    siblingDiscountPercentage:'Invalid Sibling Discount',
    surchargePercentage:'Invalid Surcharge Percentage',
    matstartDate:'Start Date is required',
    fundingLabel: 'Funding Type is required'
}
